import { Modal } from '@brighterion/br-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DeleteRuleErrorModal.css';

type Props = {
    isOpen: boolean;
    closeModal: () => void;
    confirmDeleteRule: () => void;
    title: string;
    content: string;
    onActionText: React.ReactNode;
    showCloseIcon?: true | boolean;
    disableOnCancel?: true | boolean;
    disableOnAction?: true | boolean;
};

export const DeleteRuleErrorModal = ({
    isOpen,
    closeModal,
    confirmDeleteRule,
    title,
    content,
    onActionText,
    showCloseIcon,
    disableOnCancel,
    disableOnAction
}: Props) => {
    const { t } = useTranslation();

    return (
        <Modal
            dataTestId='delete-rule-error-modal'
            isOpen={isOpen}
            closeModal={closeModal}
            status='warning'
            containerClass={styles.containerClass}
            closeOnClickOutside={false}
        >
            <Modal.Title
                id='delete-rule-error-modal-title'
                statusIcon='warning'
                title={t(title)}
                onClose={closeModal}
                showCloseIcon={showCloseIcon}
            />

            <div className={styles.errModalContent}>{t(content)}</div>

            <Modal.Footer
                id='delete-rule-error-modal-footer'
                onClose={closeModal}
                onAction={confirmDeleteRule}
                onActionText={onActionText}
                onCloseText='Cancel'
                disableOnCancel={disableOnCancel}
                disableOnAction={disableOnAction}
            />
        </Modal>
    );
};
